import _ from "lodash";
import { call, put, select } from "redux-saga/effects";

import actions from "@/actions";

import handleDuplicateFlags from "./handle-duplicate-flags/handle-duplicate-flags";

/**
 * Runs duplicate detection across all lights in the current mode.
 *
 * @yields Calls duplicate detection and dispatches flag updates.
 */
function* runDuplicates() {
    try {
        const { lights } = yield select(({ map }) =>
            _.cloneDeep(map.values.mode.present),
        );
        yield put(
            actions.window.openLoading(
                "Hold on! We're verifying all duplicates...",
            ),
        );
        yield call(handleDuplicateFlags, lights);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on running handle duplicates:", err);
    } finally {
        yield put(actions.window.closeLoading());
    }
}

export default runDuplicates;
